import { httpClient } from "./httpClient";

const base = "/api/inventario";

export const listarCatalogoDisponible = () => httpClient.get(`${base}/catalogo-disponible`);

export const listarBodegasInventario = () => httpClient.get(`${base}/bodegas`);
export const actualizarBodegaContifico = (id, contifico_bodega_id) =>
  httpClient.put(`${base}/bodegas/${id}`, { contifico_bodega_id });

export const listarProductosInventario = () => httpClient.get(`${base}/productos`);

export const crearProductoInventario = (payload) => httpClient.post(`${base}/productos`, payload);

export const actualizarStockMinimo = (id, stock_minimo) =>
  httpClient.put(`${base}/productos/${id}`, { stock_minimo });

export const listarMovimientosInventario = (params = {}) =>
  httpClient.get(`${base}/movimientos`, { params });

export const crearMovimientoInventario = (payload) => httpClient.post(`${base}/movimientos`, payload);

export const crearTrasladoInventario = (payload) => httpClient.post(`${base}/movimientos/traslado`, payload);

export const sincronizarMovimientoInventario = (id) => httpClient.post(`${base}/movimientos/${id}/sincronizar`);

export const anularMovimientoInventario = (id) => httpClient.post(`${base}/movimientos/${id}/anular`);

const inventarioService = {
  listarCatalogoDisponible,
  listarBodegasInventario,
  actualizarBodegaContifico,
  listarProductosInventario,
  crearProductoInventario,
  actualizarStockMinimo,
  listarMovimientosInventario,
  crearMovimientoInventario,
  crearTrasladoInventario,
  sincronizarMovimientoInventario,
  anularMovimientoInventario,
};

export default inventarioService;
